module.exports = __webpack_public_path__ + "img/wxCode.6b3a5950.jpg";